import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import CompactBookedSlot from "./CompactBookedSlot";
import ExtendedBookedSlot from "./ExtendedBookedSlot";

export default function BookedSlot(props: {
  slot: CalendarScheduleSlotModel;
  compact: boolean;
  onClick: (slot: CalendarScheduleSlotModel) => void;
}) {
  if (props.compact) {
    return <CompactBookedSlot {...props} />;
  }
  return <ExtendedBookedSlot {...props} />;
}
